import React from "react";
import { Button } from "reactstrap";
import Header from "../../layout/Header/Header";

// Pantallas de Compras donde se capturan precios (OC, embarques, compras
// directas, devoluciones a proveedor): sin el permiso "Ver costos en compras"
// no se entra, porque no hay forma de usarlas sin ver los costos.
export default function SinPermisoCostos() {
  return (
    <>
      <Header />
      <br />
      <br />
      <div className="card col-12" style={{ padding: 30, textAlign: "center" }}>
        <h4>Esta pantalla muestra costos de compra</h4>
        <p style={{ color: "#6c757d" }}>
          Tu usuario no tiene el permiso <b>Ver costos en compras</b>. Pídeselo a un administrador.
        </p>
        <div>
          <Button size="sm" color="danger" href="/MenuCompras">
            Regresar
          </Button>
        </div>
      </div>
    </>
  );
}
